export default function Footer() {
  const quickLinks = [
    { label: 'Accueil', href: '/' },
    { label: 'Programme', href: '/#program' },
    { label: 'Blog', href: '/blog' },
    { label: 'Avis Parents', href: '/avis-parents' },
    { label: 'Contact', href: '/#contact' }
  ];

  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="bg-gray-700/50 rounded-lg p-6 mb-8">
          <p className="text-sm text-gray-300 leading-relaxed text-center">
            <i className="ri-information-line mr-2"></i>
            Les images, photos et visuels présentés sur ce site web sont utilisés à titre illustratif seulement. Ils ne représentent pas des enfants, des parents, des lieux ou des situations réels liés à notre service de garde et n'ont aucune valeur contractuelle, conformément aux normes de protection de la vie privée en vigueur au Canada et au Québec.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-full max-w-md h-[120px] flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/8b031f960451367049584412e307a14c/3bd01b9af7138b300be51e8fd60fd9ef.png"
                  alt="Garderie Les Petits Champions"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed mb-4">
              Là où chaque enfant devient un grand champion de la vie ! Un milieu chaleureux et stimulant pour le développement global de votre enfant.
            </p>
            <p className="text-sm text-gray-400">
              Garderie agréée depuis 2001 • 24+ ans d'expérience
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3 text-gray-300">
              <p className="flex items-center space-x-2">
                <i className="ri-map-pin-line"></i>
                <span>6280 boulevard de l'Assomption<br />Montréal, QC H1T 2M8</span>
              </p>
              <p className="flex items-center space-x-2">
                <i className="ri-phone-line"></i>
                <a href="tel:5149136280" className="hover:text-white transition-colors cursor-pointer">
                  (514) 913-6280
                </a>
              </p>
              <p className="flex items-center space-x-2">
                <i className="ri-award-line"></i>
                <span>3 places disponibles</span>
              </p>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Heures d'ouverture</h4>
            <div className="space-y-2 text-gray-300">
              <p>Lundi - Vendredi</p>
              <p className="font-semibold text-lg">7h00 - 17h00</p>
              <p className="text-sm">Fermé les weekends</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>© 2001-2025 Garderie Les Petits Champions. Tous droits réservés.</p>
          <p className="mt-2">
            <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
